import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import enLang from 'vee-validate/dist/locale/en.json';
import * as rules from 'vee-validate/dist/rules';

// install rules and localization
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

extend('smallerthan', {
    params: ['target'],
    validate(value, { target }) {
        return Number(value) < Number(target);
    },
    message: 'This field has to be smaller than the {target}'
});

extend('phone', {
    validate(value) {
        const regex = /^\+?[0-9]?()[0-9]?(\s|\S)?(\d[0-9]{9})$/
        return regex.test(value);
    },
    message: 'You must enter a valid phone number'
});

extend('greaterthan', {
    params: ['target'],
    validate(value, { target }) {
        return Number(value) > Number(target);
    },
    message: 'This field has to be greater than the {target}'
});

extend('empty_leg_restriction', {
    validate(value) {
        return 0 !== Number(value);
    },
    message: 'You must be a Broker/Operator to enter a flight with no seats taken'
});

extend('phoneRestriction', {
    validate(value) {
        return 14 == value.length;
    },
    message: 'Please enter 10 digits, with no special characters'
});

extend('phoneRestrictionNullable', {
    validate(value) {
        return 14 == value.length || 0 == value.length;
    },
    message: 'Please enter 10 digits, with no special characters'
});

localize('en', enLang);

const GlobalComponents = {
    install(Vue) {
        Vue.component('ValidationObserver', ValidationObserver);
        Vue.component('ValidationProvider', ValidationProvider);
    }
};

export default GlobalComponents;